// extracted by mini-css-extract-plugin
export default {"purpleHathor":"#8c46ff"};